import './particles.js';

document.addEventListener('DOMContentLoaded', function() {
  particlesJS.load('webgl-bg-wrapper', 'js/particlesjs-config.json', function() {
    console.log('particle.js config loaded');
  });
});
